import React, { FC } from 'react';
import { useLingui } from '@lingui/react/macro';

import HowBrandWorks from '@rover/components/src/HowBrandWorks';
import {
  PageSectionId,
  useSectionRef,
} from '@rover/react-lib/src/pages/landing/SeoLocation/hooks/useSectionRef';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';
import { PetType } from '@rover/types/src/Pet';

type TrainingHowBrandWorksProps = {
  serviceTypeName: string;
};

const TrainingHowBrandWorks: FC<TrainingHowBrandWorksProps> = ({ serviceTypeName }) => {
  const { t } = useLingui();
  const sectionRef = useSectionRef(PageSectionId.HowBrandWorks);
  const brandDisplayName = getBrandDisplayName();

  const steps = [
    {
      heading: t`Search`,
      content: t`Read verified reviews and choose a trainer who’s a great match for you and your dog.`,
    },
    {
      heading: t`Chat with your trainer`,
      content: t`Talk about your training goals and find a time that works for you.`,
    },
    {
      heading: t`Book & Pay`,
      content: t`It's that easy! All payments are processed through ${brandDisplayName}'s secured platform.`,
    },
  ];

  return (
    <HowBrandWorks htmlRef={sectionRef}>
      <HowBrandWorks.Display variant="heading" size="600">
        {t`How to book ${serviceTypeName}`}
      </HowBrandWorks.Display>
      <HowBrandWorks.List petType={PetType.DOG}>
        {steps.map(({ heading, content }, index) => (
          <HowBrandWorks.ListItem key={heading}>
            <HowBrandWorks.ItemHeading step={index + 1}>{heading}</HowBrandWorks.ItemHeading>
            <HowBrandWorks.ItemContent>{content}</HowBrandWorks.ItemContent>
          </HowBrandWorks.ListItem>
        ))}
      </HowBrandWorks.List>
    </HowBrandWorks>
  );
};

export default TrainingHowBrandWorks;
